import { render, staticRenderFns } from "./AutorisationDeCollectionDeDonneesSigne.vue?vue&type=template&id=53d0cc24&scoped=true"
import script from "./AutorisationDeCollectionDeDonneesSigne.vue?vue&type=script&lang=js"
export * from "./AutorisationDeCollectionDeDonneesSigne.vue?vue&type=script&lang=js"
import style0 from "./AutorisationDeCollectionDeDonneesSigne.vue?vue&type=style&index=0&id=53d0cc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d0cc24",
  null
  
)

export default component.exports